import { observable, action } from 'mobx';
import ApiCaller from '../utils/api-caller';
import moment from 'moment';

class AuditLogStore {
    // Properties

    @observable areas = [
        { value: 'ALL', label: 'All' },
        { value: 'Task', label: 'Task' },
        { value: 'Task Language', label: 'Task Language' },
    ];

    @observable actions = [
        { value: 'ALL', label: 'All' },
        { value: 'INSERT', label: 'INSERT' },
        { value: 'UPDATE', label: 'UPDATE' },
        { value: 'DELETE', label: 'DELETE' },
    ];

    // Modal Create/Update Properties

    @observable showAuditLogModal = false;
    @observable auditLogTitle = '';

    @observable tabNameActiveKey = '1';
    @observable tabDescriptionActiveKey = '1';

    @observable auditLog = null;
    @observable auditLogs = [];

    @observable totalData = 0;

    // Helper Properties

    @observable auditLogListLoading = false;
    @observable auditLogModalLoading = false;

    // Initialization

    @action initAuditLog(fromDate, endDate, currentPage, pageSize, area, areaId, action, username) {
        this.auditLogListLoading = true;

        let fromDateTime = moment(fromDate).format('DD/MM/YYYY');
        let toDateTime = moment(endDate).format('DD/MM/YYYY');

        var request = {
            'fromDate': fromDateTime,
            'toDate': toDateTime,
            'currentPage': currentPage,
            'pageSize': pageSize,
            'area': area,
            'areaId': areaId,
            'action': action,
            'username': username,
        };

        return ApiCaller.AuditLogs.get(request).then(resp => {
            if (resp.isSuccess) {
                resp.model.map(m => {
                    return m.createdDate = moment(m.createdDate).format('DD/MM/yyyy HH:mm:ss');
                })
                this.auditLogs = resp.model;
                this.totalData = resp.totalData;
                this.auditLogListLoading = false;
            } else {
                this.auditLogs = [];
                this.totalData = 0;
                this.auditLogListLoading = false;
            }
        });
    }

    @action initUpdateAuditLog(id) {
        this.auditLogModalLoading = true;
        this.auditLogTitle = 'Audit Log Detail';
        this.showAuditLogModal = true;

        this.auditLog = this.auditLogs.find(fi => fi.id === id);
        this.auditLogModalLoading = false;
    }

    // SET Properties

    @action setShowAuditLogModal(value) {
        this.showAuditLogModal = value;
        if (!value) {
            this.tabNameActiveKey = '1';
            this.tabDescriptionActiveKey = '1';
        }
    }

    @action setshowAuditLogModal(value) {
        this.showAuditLogModal = value;
    }
}

export default new AuditLogStore()
